const pix4D = {
  key: "pix-4d",
  title: "Pix4D Integration",
  angle: 140,
  summary: "Real-time photogrammetry integration with 3D models.",
  releaseDate: "Early 2027",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: false,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: false,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Initial data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Jan 27",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Mar 27",
    },
  ],
  points: [
    "Capture and process site information that shows in the model in real time ",
    "Data association with real world information",
    "Reduce rework and improve decision making with accurate, up-to-date information",
  ],
};

export default pix4D;
